import React from "react";
// @ts-ignore
import { InpostGeowidget } from "react-inpost-geowidget";

const DeliveryMethod = () => {

    const onPointCallback = (e: any) => {
        console.log(e);
    }

    return (
        <div className="mt-10 border-t border-gray-200 pt-10">
            <h2 className="text-lg font-medium text-gray-900">Dostawa</h2>
            <fieldset className="mt-4">
                <legend className="sr-only">Payment type</legend>
                <div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0 mb-4">
                    <p className="text-sm font-medium text-gray-700">Aktualnie dostawa realizowana jest jedynie przez
                        firmę InPost.</p>
                </div>
                <InpostGeowidget
                    token={"eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJkVzROZW9TeXk0OHpCOHg4emdZX2t5dFNiWHY3blZ0eFVGVFpzWV9TUFA4In0.eyJleHAiOjIwMzc0NzAyMDMsImlhdCI6MTcyMjExMDIwMywianRpIjoiMzE2MzEwZDEtM2E4OC00M2JlLThkZmMtYjAwNjQwODZkZDM4IiwiaXNzIjoiaHR0cHM6Ly9zYW5kYm94LWxvZ2luLmlucG9zdC5wbC9hdXRoL3JlYWxtcy9leHRlcm5hbCIsInN1YiI6ImY6N2ZiZjQxYmEtYTEzZC00MGQzLTk1ZjYtOThhMmIxYmFlNjdiOlJTUkc1elVSaWZrZFZhRWQ5MWwxdl96RTBuQnRzNGxpak1TQWkxTU9XeHciLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJzaGlweCIsInNlc3Npb25fc3RhdGUiOiIxZGQ5NjFhMS0xOTQ4LTRhYjEtYTIzMC05YTUxMGM1OTgwYWUiLCJzY29wZSI6Im9wZW5pZCBhcGk6YXBpcG9pbnRzIiwic2lkIjoiMWRkOTYxYTEtMTk0OC00YWIxLWEyMzAtOWE1MTBjNTk4MGFlIiwiYWxsb3dlZF9yZWZlcnJlcnMiOiIqLm1ldGNvbmxvdmVycy5jb20iLCJ1dWlkIjoiZjI3NmM4ZTItZjVjMC00MGFlLWJkOGItOTdmMWUzY2QyZjRiIn0.AOL8dWSBSNgv5rWmt4NoceWVqa04X1ojy_08MiBZt9fUmr6VPZ6Rac4K2O8F6s9aOoya1WIFHYXSk7uIf6eEVigmxroX39c-f20WjRYcaVQ1dSd7ZPG0OTRd0kGuEbML0pbsDPUwbBa3b8DltOOtmuuCVghQws91gnsScE0fZF0ysv4fBxitItOVRe9Lgiz0IDdjdnLbwTZETcVrsABJcJkGgoLY916qQ-PrknHgAROURkdF2me6zyRAthg2-lZN_5rYzTQUeO5AMgVXMFUxdQTNnzu7R8Ukz4TO3dmzJhgqjAw3Kuuo06WMxsTc4DAtE31jAFvcVxQk9R6u8v7d_w"}
                    onPoint={onPointCallback}
                />
            </fieldset>
        </div>
    );
}

export default DeliveryMethod;